import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
    <g clipPath='url(#a)'>
      <path
        fill='#DDD'
        d='M20.71 3.655s1.942-.758 1.78 1.082c-.053.757-.54 3.408-.917 6.276l-1.295 8.495s-.108 1.244-1.08 1.46c-.97.217-2.427-.757-2.697-.973-.216-.162-4.047-2.597-5.397-3.788-.377-.324-.81-.974.055-1.73l5.666-5.41c.647-.65 1.295-2.166-1.403-.326l-7.555 5.14s-.864.54-2.482.054l-3.508-1.082s-1.295-.812.917-1.623C8.19 8.685 14.828 6.09 20.71 3.654v.001Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export const TelegramIcon2 = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='stroke'
    >
      <g clipPath='url(#clip0_1765_2005)'>
        <g clipPath='url(#clip1_1765_2005)'>
          <path
            d='M11.5241 13.8041C11.6962 13.8831 11.8901 13.9012 12.0738 13.8553C12.2575 13.8094 12.4202 13.7022 12.5349 13.5516L12.8307 13.1641C12.986 12.9571 13.1873 12.7891 13.4187 12.6734C13.6501 12.5576 13.9053 12.4974 14.1641 12.4974H16.6641C17.1061 12.4974 17.53 12.673 17.8426 12.9856C18.1551 13.2981 18.3307 13.722 18.3307 14.1641V16.6641C18.3307 17.1061 18.1551 17.53 17.8426 17.8426C17.53 18.1551 17.1061 18.3307 16.6641 18.3307C12.6858 18.3307 8.87051 16.7504 6.05746 13.9373C3.24442 11.1243 1.66406 7.30898 1.66406 3.33073C1.66406 2.8887 1.83966 2.46478 2.15222 2.15222C2.46478 1.83966 2.8887 1.66406 3.33073 1.66406H5.83073C6.27276 1.66406 6.69668 1.83966 7.00924 2.15222C7.3218 2.46478 7.4974 2.8887 7.4974 3.33073V5.83073C7.4974 6.08947 7.43715 6.34466 7.32144 6.57609C7.20573 6.80751 7.03772 7.00882 6.83073 7.16406L6.44073 7.45656C6.28774 7.57338 6.17991 7.73955 6.13555 7.92685C6.0912 8.11416 6.11305 8.31104 6.1974 8.48406C7.3363 10.7973 9.20942 12.6681 11.5241 13.8041Z'
            stroke='current'
            strokeWidth='1.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_1765_2005'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
        <clipPath id='clip1_1765_2005'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default SvgComponent
